export const ThemeColor = "#2e3192";
export const ThemeBorderColor = "#ab3706";
export const DarkThemeColor = "#353547";
export const CardColor = "#fefefe";
export const hoverEffect = `rgba(52, 52, 52, 0.56) 0px 22px 70px 4px`;
export const lotteryHoverEffect = `rgba(87, 87, 87, 0.56) 0px 12px 30px 2px`;
export const cardShadow = `rgba(219, 87, 38, 0.1) 0px 20px 25px -5px,
    rgba(219, 87, 38, 0.04) 0px 10px 10px -5px`;